import { ViewFactory } from 'wdc-cube-react'
import GrupoFormScope from '../grupo_form.scopes'
import GrupoFormView from './grupo_form.view'

export function registerViews(rv = ViewFactory.register) {
    rv(GrupoFormScope, GrupoFormView)
}
